import React, { useContext } from "react";
import CART from "components/context/CartContext";
import USER from "components/context/UserContext";
import axios from "axios";
import swal from "sweetalert";
import { server_api } from "config/config";

function getEventCodesFromCart(cart) {
  if (!cart) return [];

  const eventCodes = cart.map((item) => item.id);
  return eventCodes;
}

export default function CheckoutAction({ setLoading }) {
  const { cart } = useContext(CART);
  const { user } = useContext(USER);

  async function checkout() {
    setLoading(true);

    const codes = getEventCodesFromCart(cart);

    const res = await axios({
      method: "POST",
      headers: {
        Authorization: user.token,
      },
      baseURL: server_api,
      url: "invoices/create",
      data: { eventCodes: codes },
    }).catch((err) => {
      // console.log(err);
    });

    // console.log(res);

    if (res?.data?.success) {
      window.open(res.data.order, "_self");
    } else {
      swal("Oops!", "Something Went Wrong! Please Try Again", "warning");
    }

    setLoading(false);
  }

  if (cart?.length > 0) {
    return (
      <div>
        <button
          className="mx-8 my-2 px-2 py-1 rounded-lg bg-red/50 drop-shadow-[0_0_0.3rem_red] hover:bg-transparent border-2 border-red transition-all"
          onClick={checkout}
        >
          Continue
        </button>
      </div>
    );
  } else return "";
}
